import React, { useState, useEffect } from "react";
import Joi from "joi-browser";
import http from "../../Services/httpService";
import config from "../../config.json";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";

const LoginStep1 = ({ handleStep1, userError, type }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const schema = {
    validId: Joi.string().required().label("Valid ID"),
  };

  const doSubmit = async () => {
    setIsProcessing(true);
    try {
      // 1. Validate ValidId and obtain ChallengeId from the new Auth start API
      const { data: startResult } = await http.post(
        config.AuthStart || "Auth/start",
        {
          validId: stateData["validId"],
          portalType: "customer",
        }
      );
      localStorage.setItem("challengeId", startResult.challengeId);

      let userType = "applicant";
      // 2. Query GetUserType to resolve layout-level user types (recruiter, candidate, subcontractor)
      try {
        const { data: userTypeResult } = await http.get(
          config.GetUserType + stateData["validId"]
        );
        userType = userTypeResult;
      } catch (userTypeErr) {
        // Fallback default
        userType = "applicant";
      }

      localStorage.setItem("userType", userType);
      handleStep1({ ...stateData, userType });
    } catch (err) {
      const res = err.response;
      let isInactive = res?.data === "inactive" || res?.data?.message === "inactive";
      
      // Inspect legacy endpoint to determine if failure was due to account deactivation
      if (!isInactive) {
        try {
          await http.get(config.GetUserType + stateData["validId"]);
        } catch (typeErr) {
          if (typeErr.response?.data === "inactive") {
            isInactive = true;
          }
        }
      }

      const errorMessage = isInactive
        ? "Your account has been deactivated, please contact system administrator systemadmin@workfinity.com"
        : "Invalid Id";

      setStateErrors((prev) => ({
        ...prev,
        validId: errorMessage,
      }));
    } finally {
      setIsProcessing(false);
    }
  };

  const {
    stateData,
    stateErrors,
    setStateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  useEffect(() => {
    if (userError !== undefined) {
      setStateErrors((prev) => ({
        ...prev,
        validId: userError,
      }));
    }
  }, [userError, setStateErrors]);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <React.Fragment>
      {renderInput("validId", "Enter Your Valid ID")}
      <button
        className="btn w-100"
        style={{
          backgroundColor: `${type === "admin" ? "#298607" : "#2b62a1"}`,
          color: "white",
        }}
        disabled={!!validate() || isProcessing}
        onClick={handleSubmit}
      >
        {isProcessing ? (
          <i className="fa fa-refresh fa-spin mr-2" aria-hidden="true"></i>
        ) : (
          <i className="fa fa-arrow-right mr-2" aria-hidden="true"></i>
        )}
        {isProcessing ? "Processing..." : "Next"}
      </button>
    </React.Fragment>
  );
};

export default LoginStep1;
